export default __webpack_public_path__ + "static/media/Audi2021.77364343.png";